import { css, keyframes } from '@emotion/react';
import { theme } from '../../theme/theme';

const popIn = keyframes`
  from { transform: scale(0.96); opacity: 0; }
  to { transform: scale(1); opacity: 1; }
`;

/** 뷰포트 전체를 덮는 반투명 백드롭. 중앙 정렬로 다이얼로그를 띄운다. */
export const backdropStyle = css`
  position: fixed;
  inset: 0;
  z-index: 1100;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: ${theme.space.md}px;
  background: rgba(17, 24, 39, 0.35);
`;

/** 중앙 다이얼로그 패널. */
export const panelStyle = css`
  width: min(420px, 92vw);
  background: ${theme.color.surface};
  border-radius: ${theme.radius.md}px;
  box-shadow: 0 12px 32px rgba(0, 0, 0, 0.22);
  padding: ${theme.space.lg}px;
  animation: ${popIn} 0.16s ease-out;
`;

export const titleStyle = css`
  margin: 0 0 ${theme.space.sm}px;
  font-size: ${theme.fontSize.lg}px;
  color: ${theme.color.text};
`;

export const messageStyle = css`
  margin: 0 0 ${theme.space.lg}px;
  font-size: ${theme.fontSize.md}px;
  line-height: 1.5;
  color: ${theme.color.textMuted};
`;

/** 버튼 줄 — 오른쪽 정렬. */
export const actionsStyle = css`
  display: flex;
  justify-content: flex-end;
  gap: ${theme.space.sm}px;
`;
